var map = {
	"./continue_playing.png": 128,
	"./start.png": 129,
	"./victory.png": 130,
	"./victory2.png": 131,
	"./welldone.png": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe ^\.\/.*$
// module id = 228
// module chunks = 0